
import { PropTypes } from 'prop-types';
import { useSearchParams } from 'react-router-dom';

const PreUniversity = ({ handleAllowNext }) => {
    const [,setSearchParams] = useSearchParams()

    const handleChange = (e) => {
        if (e.target.value != "") {
            handleAllowNext()
            
            setSearchParams(searchParams => {
                searchParams.set("educationResult", e.target.value);
                return searchParams;
            });

        }
        else {
            handleAllowNext(false)
            setSearchParams(searchParams => {
                searchParams.delete("educationResult");
                return searchParams;
            });
        }
    }


    return (
        <div className="flex flex-col gap-5">
            <h2 className="text-xl font-semibold">What is your cgpa ?</h2>
            {/* show textbox to enter cgpa */}
            <input type="number" onChange={handleChange} className="border max-w-xs border-gray-200 p-4 rounded-lg placeholder:text-[#FFA18F] text-[#8C1600] outline-none" placeholder="Enter your cgpa" />
        </div>
    )
}
PreUniversity.propTypes = {
    handleAllowNext: PropTypes.any
}
export default PreUniversity